import Quill from 'quill'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.bubble.css'
import './quill.size.css'
import './quill.font.css'
// import './quill.header.css'

// 配置自定义字号
let fontSize = ['14px', '16px', '18px', '20px', '30px', '32px']
Quill.imports['attributors/style/size'].whitelist = fontSize
Quill.register(Quill.imports['attributors/style/size'], true)

// 配置自定义字体
var fonts = ['Microsoft-YaHei', 'SimSun', 'SimHei', 'KaiTi', 'FangSong', 'Arial', 'Times-New-Roman', 'sans-serif']
var Font = Quill.import('formats/font')
Font.whitelist = fonts // 将字体加入到白名单
Quill.register(Font, true)



// WEBPACK FOOTER //
// ./src/utils/quill/index.js